import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import { placesClient } from '../../../utils/apollo/api'
import { useOpenEditPlaceModal } from '../../../utils/routes/modals/modalsActions'
import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import { useSavePlaceLevel } from '../../places/placeLevelsSelect/_requests/savePlaceLevel'
import Select from '../../../packages/kiti/components/form/Select'
import { formatPlaceTypePermission } from '../../../utils/helpers/placeTypes'

const QUERY = gql`
  query PlaceLevels($search: String, $page: Int, $filter: PlaceLevelFilter) {
    placeLevels(search: $search, page: $page, filter: $filter, sort: { field: NAME, type: ASC }) {
      id
      name
      levelId
      resume
      placeLevelsResume
    }
  }
`

export const usePlaceLevelsLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: placesClient })
  return (search, page = 1) => {
    return query({ search, page, filter })?.then(pathOr([], ['data', 'placeLevels']))
  }
}

const PlaceLevelSelect = ({ onChange, value, types, parentIds, levelIds, ...props }) => {
  const canCreateNew = useSessionPermission(`create${formatPlaceTypePermission(types)}sPlaceLevel`)
  const getOptions = usePlaceLevelsLoader({ types, parentIds, levelIds })
  const openCreateModal = useOpenEditPlaceModal({ outside: true })

  const onSuccess = result => onChange(result)
  const [onCreate, { loading }] = useSavePlaceLevel(onSuccess, { parentId: parentIds, levelId: levelIds, type: types })

  return (
    <Select
      value={value} //
      onChange={onChange}
      onCreate={canCreateNew && onCreate}
      options={getOptions}
      descriptionField="resume"
      loading={loading}
      {...props}
    />
  )
}

export default PlaceLevelSelect
